<template>
  <OptionsGrid>
    <OptionsGridItem>
      <template slot="label">Permitir que outras pessoas possam visualizar seu perfil</template>
      <BaseCheckbox v-model="settings.is_profile_public" />
    </OptionsGridItem>

    <OptionsGridItem>
      <template slot="label">Permitir que outras pessoas possam visualizar suas atividades</template>
      <BaseCheckbox v-model="settings.is_activities_public" />
    </OptionsGridItem>
  </OptionsGrid>
</template>

<script>
import BaseCheckbox from '@/components/form/BaseCheckbox'
import OptionsGrid from '@/components/grid/OptionsGrid'
import OptionsGridItem from '@/components/grid/OptionsGridItem'

export default {
  components: {
    BaseCheckbox,
    OptionsGrid,
    OptionsGridItem,
  },

  props: {
    settings: { type: Object, required: true }
  },
}
</script>